import { FunctionComponent, ReactNode } from 'react'
import { Link } from 'react-router-dom'

import BrandLogo from 'components/ui/brandLogo'
import AuthFooter from './authFooter'
import authCss from './auth.module.scss'

/** Centered card used by sign-up and password pages. */
const AuthCardLayout: FunctionComponent<{
  title: ReactNode
  subtitle?: ReactNode
  badge?: ReactNode
  children: ReactNode
}> = ({ title, subtitle, badge, children }) => (
  <div className={authCss.cardPage}>
    <header className={authCss.cardHeader}>
      <Link to="/login" aria-label="Clic-repasse – login">
        <BrandLogo />
      </Link>
    </header>
    <main className={authCss.cardMain}>
      <section className={`card ${authCss.authCard}`}>
        {badge && <span className={authCss.badge}>{badge}</span>}
        <h1 className={authCss.title}>{title}</h1>
        {subtitle && <p className={authCss.subtitle}>{subtitle}</p>}
        <div className={authCss.body}>{children}</div>
      </section>
    </main>
    <AuthFooter />
  </div>
)

export default AuthCardLayout
